import { Form, Input } from "antd"
import React from "react"

interface FreeTextBlockProps {
  fieldKey: string
}

export function FreeTextBlock({ fieldKey }: FreeTextBlockProps) {
  return (
    <>
      <Form.Item
        name={["block_data", fieldKey, "title"]}
        label="Section Title"
        rules={[
          { required: true, whitespace: true, message: "Title is required" }
        ]}
      >
        <Input placeholder="Enter title" />
      </Form.Item>

      <Form.Item
        name={["block_data", fieldKey, "content"]}
        label="Content"
        rules={[
          { required: true, whitespace: true, message: "Content is required" }
        ]}
      >
        <Input.TextArea placeholder={"Enter content"} rows={5} />
      </Form.Item>
    </>
  )
}
